import LandscapeProductCard from './LandscapeProductCard'
import { ProductCardProps } from '../ProductCard'
export default LandscapeProductCard
export type { ProductCardProps }
